import type React from "react";

import { Checkbox, Header, Label } from "simplydo/react/ui";

type CheckboxHeaderProps = {
  as?: string;
  header: React.ReactNode;
  description?: React.ReactNode;
  label?: string;
  checked?: boolean;
  onChange: (checked: boolean) => void;
  children?: React.ReactNode;
  plain?: boolean;
  willHideChildren?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
};

export const CheckboxHeader = ({
  as,
  header,
  description,
  label,
  checked,
  onChange,
  children,
  plain,
  willHideChildren,
  disabled,
  style = {},
}: CheckboxHeaderProps) => {
  return (
    <div style={{ marginBottom: 20, display: "flex", ...style }}>
      <div style={{ textAlign: "center", paddingTop: 10 }}>
        <Checkbox
          tabIndex={0}
          disabled={disabled}
          toggle={!plain}
          checked={checked}
          onChange={(_e, c) => onChange(c.checked ?? false)}
        />
      </div>
      <div
        style={{
          paddingLeft: 15,
          paddingRight: 15,
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Header
          as={as}
          style={{ marginBottom: 5, cursor: !disabled && "pointer" }}
          onClick={(e: React.MouseEvent) => {
            if (!disabled) {
              e.stopPropagation();
              onChange(!checked);
            }
          }}
        >
          {header} {label && <Label>{label}</Label>}
        </Header>
        {description ? (
          <span
            onClick={(e: React.MouseEvent) => {
              if (!disabled) {
                e.stopPropagation();
                onChange(!checked);
              }
            }}
          >
            {description}
          </span>
        ) : null}
        {willHideChildren && !checked ? null : (
          <div style={{ marginTop: 5 }}>{children}</div>
        )}
      </div>
    </div>
  );
};
